import { render } from "./xTrackPage.vue?vue&type=template&id=1047a2d6&scoped=true"
import script from "./xTrackPage.vue?vue&type=script&lang=js"
export * from "./xTrackPage.vue?vue&type=script&lang=js"

import "./xTrackPage.vue?vue&type=style&index=0&id=1047a2d6&scoped=true&lang=scss"
import "./xTrackPage.vue?vue&type=style&index=1&id=1047a2d6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1047a2d6"]])

export default __exports__